/**
 * パンくずリスト
 * MEMO: SEO 施策により追加したマルチタイプのパンくずリストを開閉する制御
 */

/**
 * パンくずリストの開閉制御を初期化
 */
export const initBreadcrumb = (): void => {
    const breadTrigger = document.querySelector<HTMLElement>('#bread-trigger')
    if(!breadTrigger) return

    breadTrigger.addEventListener('click', () => {
        breadTrigger.classList.toggle('is-active')
        const secondary = document.querySelector<HTMLElement>('.p-bread-multi_secondary')
        if(!secondary) return
        secondary.style.display = secondary.style.display==='none' || !secondary.style.display ? 'block' : 'none'
    })
}
